//Styles
import Styles from "./BaseMobileAppContainer.module.scss";
import classnames from "classnames";

//module
import Draggable from 'react-draggable'

//Components
// import WindowOptions from "./window-options/WindowOptions";

//Icon
import { ReactNode,  useEffect,  useState } from "react";


//Redux
import { closeWindow, closeAllApps, handleDisableTaskView, handleToggleTaskView } from "../../../actions";
import { RootStateOrAny, useDispatch } from "react-redux";
import { changeDragable } from "../../../reducers/draggable";
import { useSelector } from "react-redux";
import { useTransition, animated } from "react-spring";
import { getSizeInRem, gotoPreviousOption } from "../../../global/functions/functrions";
import ActionCenter from "../action-center/ActionCenter";
import NavigationBar from "../navigation-bar/NavigationBar";
import { useSwipeable } from "react-swipeable";
import handleTaskView from "../../../reducers/taskView";
import AppPanel, { MOBILE_APPS } from "../app-panel/AppPanel";

interface BaseMobileAppContainerProps {
    appId: string;
    loadFromX?: number;
    loadFromY?: number;
    title: string;
    isMainScreenActive?: boolean;
    MainMenuOptions?: ReactNode;
    MainScreen: ReactNode | null;
    isForcedCompactView?:boolean;
    forcedBackClickDeroute?:boolean;
    onClickBackButton?: () => void;
    handleBackClick?: (data?: any) => void;
    onClosedSuccessfully?:(data?:any)=>void;
}


const BaseMobileAppContainer = ({ appId, loadFromX = 500, loadFromY = 1000, title, isMainScreenActive = false, MainMenuOptions, MainScreen,isForcedCompactView=false,forcedBackClickDeroute=false, onClickBackButton, handleBackClick,onClosedSuccessfully }: BaseMobileAppContainerProps) => {

    const [isVisible, setIsVisible] = useState(true)
    const [isSwiped, setIsSwiped] = useState(isForcedCompactView)

    const isTaskViewEnabled = useSelector((state: RootStateOrAny) => state.handleTaskView)

    const dispatch = useDispatch()

    useEffect(()=>{

    },[isForcedCompactView])

    const handler = useSwipeable({
        onSwipedUp: (event) => {
            if (isTaskViewEnabled) {
                dispatch(closeWindow(appId))
                dispatch(handleToggleTaskView())
            }
            else {
                if (event.velocity > 0.66666) {
                    setIsSwiped(true)
                }
            }
        },
        onSwipedDown: (event) => {
            if (isTaskViewEnabled) {
                dispatch(closeWindow(appId))
                dispatch(handleToggleTaskView())
            }
            else {
                if (event.velocity > 0.66666) {
                    setIsSwiped(false)
                }
            }
        },
    })

    const onClickCLoseWindow = () => {
        setIsVisible(false)
        setTimeout(() => {
            dispatch(closeWindow(appId))
        }, 100)
    }

    const transition = useTransition(isVisible, {
        from: {
            scale: 0
        },
        enter: {
            scale: 1
        },
        leave: {
            scale: 0
        }
    })


    const handleScreenClick = (e: any) => {
        e.stopPropagation()
        dispatch(handleDisableTaskView())
    }

    const handleCLoseAllApps = () => {
        dispatch(closeAllApps())
        dispatch(handleDisableTaskView())
    }


    return (
        <div className={isTaskViewEnabled ? Styles.task_view : ""}>
            <Draggable disabled={!isTaskViewEnabled}>
                <div className={classnames(Styles.container)} >
                    {
                        isTaskViewEnabled && (
                            <div className={Styles.app_badge} id={appId} />
                        )
                    }
                    {isMainScreenActive && MainScreen
                        ? <div className={Styles.main_screen} onClick={handleScreenClick}>{MainScreen}</div>
                        : <>
                            {
                                title && (
                                    <div className={isSwiped ? Styles.top_flex_container_small : Styles.top_flex_container} onClick={handleScreenClick}>
                                        <div className={Styles.title}>
                                            {title}
                                        </div>
                                    </div>
                                )
                            }
                            <div className={Styles.content_flex_container} {...handler} style={{borderRadius:`${MainMenuOptions?"0px":"0px"}`}} onClick={handleScreenClick}>
                                {MainMenuOptions}
                            </div>
                        </>
                    }
                    {
                        !isTaskViewEnabled &&
                        (
                            <div className={Styles.navigation_bar}>
                                <NavigationBar appId={appId} onBackClick={(isMainScreenActive || forcedBackClickDeroute) && handleBackClick ? handleBackClick : undefined}  onSuccessfullyClosed={onClosedSuccessfully}/>
                            </div>
                        )
                    }

                </div>
            </Draggable>
            {
                isTaskViewEnabled &&
                (
                    <div className={Styles.bottom_bar}>
                        <div className={Styles.clear_button} onClick={handleCLoseAllApps} >Close All</div>
                        <AppPanel />
                    </div>
                )
            }
        </div >
    )
}

export default BaseMobileAppContainer


